"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing,
      palette = _ref.palette,
      breakpoints = _ref.breakpoints;
  return {
    root: {
      width: '100%',
      height: '100%',
      minHeight: '100vh',
      backgroundColor: palette.primary.main,
      padding: spacing(3, 6),
      [breakpoints.down('xs')]: {
        padding: spacing(3, 2)
      }
    }
  };
});

var Layout = function Layout(_ref2) {
  var children = _ref2.children;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.root
  }, children);
};

var _default = /*#__PURE__*/(0, _react.memo)(Layout);

exports.default = _default;